<template>
  <div>
    <v-container style="height: 400px;">
      <v-card class="mx-auto" max-width="600" elevation="10">
        <v-row class="fill-height" align-content="center" justify="center" >
          <v-col class="title text-center" cols="12">
            {{ $t('message.login.redirectToSo') }}...
          </v-col>
          <v-col cols="6" class="text-center">
            <v-progress-circular :size="70" :width="7" color="primary" class="mx-auto" indeterminate></v-progress-circular>
          </v-col>
          <v-col cols="12" class="text-center">
            NOTE: <kbd>Please Allow Popup</kbd> from preventing redirection to SuperOffice
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>
<script>
export default {
  mounted () {
    window.open(`${process.env.VUE_APP_SO_FEDERATED_URL}&redirect_url=${process.env.VUE_APP_SO_REDIRECT_URL}`, '_self')
  }
}
</script>
